import { UserClaimModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';
import { nameOverrides } from './overrides';

const defaultUserClaim: UserClaimModelDto = {
    claimId: 0,
    claimName: '',
};

export class UserClaim extends DomainEntity<UserClaimModelDto> {
    public get id() {
        return this.dto.claimId ?? 0;
    }

    public get name() {
        if (!this.dto.claimName) {
            return '';
        }

        return nameOverrides[this.dto.claimName] || this.dto.claimName;
    }

    public get description() {
        return this.dto.claimDescription;
    }

    public get hasUserClaim() {
        return this.dto.hasUserClaim ?? false;
    }

    public set hasUserClaim(value: boolean) {
        this.dto.hasUserClaim = value;
    }

    public get hasPendingUserClaim() {
        return this.dto.hasPendingUserClaim ?? false;
    }

    public get claimChanged() {
        return this.dto.hasUserClaim !== this.dto.hasPendingUserClaim;
    }

    public createDefault(): this {
        return new UserClaim(defaultUserClaim) as this;
    }
}
